import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-md-10" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "fw-bold text-secondary" }
const _hoisted_9 = { class: "overflow-hidden" }
const _hoisted_10 = {
  key: 1,
  class: "text-center pt-3"
}
const _hoisted_11 = {
  key: 1,
  class: "loading-card-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Scenarios Approved", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.visit_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (Object.keys(_ctx.props.scenario_approved).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.scenario_approved, (approved) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: approved.id,
                      class: "row scenario-card",
                      onClick: ($event: any) => (_ctx.router.push({name:'scenario.show',params:{id:approved.id}}))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: approved.patient_image.location,
                          class: "rounded-circle float-start",
                          width: "75"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(approved.patient_name), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(approved.title), 1)
                        ])
                      ]),
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-md-2 d-flex flex-column justify-content-center" }, [
                        _createElementVNode("h3", { class: "text-center" }, [
                          _createElementVNode("i", { class: "fas fa-check-circle text-primary" })
                        ])
                      ], -1)),
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-12 thin-line" }, null, -1))
                    ], 8, _hoisted_5))
                  }), 128)),
                  (Object.keys(_ctx.props.scenario_approved).length > 10)
                    ? (_openBlock(), _createBlock(_component_pagination, {
                        key: 0,
                        items: _ctx.props.scenario_approved,
                        page_start: _ctx.page_start,
                        page_end: _ctx.page_end,
                        onNextPage: _ctx.nextPage,
                        onPreviousPage: _ctx.previousPage,
                        label: 'Scenarios'
                      }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_10, "No Scenarios have been Approved"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_loading, {
              active: _ctx.visit_loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}